import React from 'react';

function PageHero({ hero, visual }) {
  return (
    <section className="hero">
      <div className="hero-content">
        <div>
          <div className="eyebrow">{hero.eyebrow}</div>
          <h2>
            {hero.titlePrefix}
            <span className="grad">{hero.titleAccent}</span>
            {hero.titleSuffix}
          </h2>
          <p>{hero.description}</p>
          {hero.badges.length > 0 ? (
            <div className="sector-strip">
              {hero.badges.map((badge) => {
                const isGold = (hero.goldBadges || []).includes(badge);
                return (
                  <span
                    className={`badge ${isGold ? 'badge--gold' : ''}`.trim()}
                    key={badge}
                  >
                    {badge}
                  </span>
                );
              })}
            </div>
          ) : null}
          <div className="button-group">
            <a className="button primary" href={hero.primaryHref}>
              {hero.primaryLabel}
            </a>
            <a className="button secondary" href={hero.secondaryHref}>
              {hero.secondaryLabel}
            </a>
          </div>
        </div>
        <div className="hero-visual">{visual}</div>
      </div>
    </section>
  );
}

export default PageHero;